import * as React from "react"
import PropTypes from "prop-types"
import { AccordionContext } from "components/Accordion"
import { Text } from "components/Text"
import { PlusCircle } from "components/Icon/PlusCircle"
import { MinusCircle } from "components/Icon/MinusCircle"

const CollapsedIcon = () => {
  return <PlusCircle className="w-4" />
}

const ExpandedIcon = () => {
  return <MinusCircle className="w-4" />
}

export const AccordionSummary = ({
  children,
  headingLevel = 2,
  collapsedIcon: collapsedIconProps,
  expandedIcon: expandedIconProps,
  disabled = false,
}) => {
  const { expanded, setExpanded, accordionSummaryId, accordionContentId } =
    React.useContext(AccordionContext)

  const Component = "h" + headingLevel

  const collapsedIcon = collapsedIconProps || <CollapsedIcon />
  const expandedIcon = expandedIconProps || <ExpandedIcon />
  const icon = expanded ? expandedIcon : collapsedIcon

  return (
    <Component>
      <button
        type="button"
        className="flex flex-row w-full justify-between items-center space-x-8 focus:outline-hidden text-left"
        onClick={() => setExpanded((expanded) => !expanded)}
        aria-expanded={expanded ? "true" : "false"}
        aria-controls={accordionContentId}
        aria-labelledby={accordionSummaryId}
        disabled={disabled}
      >
        <Text
          variant="headline5"
          tag="span"
          id={accordionSummaryId}
          className="text-default"
        >
          {children}
        </Text>
        {disabled ? null : <div className="text-primary-dark">{icon}</div>}
      </button>
    </Component>
  )
}

AccordionSummary.propTypes = {
  children: PropTypes.node,
  headingLevel: PropTypes.number,
  className: PropTypes.string,
  disabled: PropTypes.bool,
}
